import { Button, Text } from "north.js";
import React from "react";
import styled from "styled-components";

import { Header, PageWrapper } from "src/shared/components";
import { HackerDirectoryEmptyProfileCard } from "src/static/img";

const EmptyProfile: React.FC<{ onCreate: () => void }> = ({ onCreate }) => (
  <>
    <Header
      title="My Profile"
      subtitle="Edit your directory card details, update your project goals, and manage your team status."
    />
    <EmptyProfilePageWrapper stretchHeight={false}>
      <EmptyProfileLayout>
        <EmptyProfileContent>
          <EmptyProfileTitle type="h3">
            You haven&rsquo;t created a directory profile yet!
          </EmptyProfileTitle>
          <EmptyProfileDescription type="body1">
            Build your profile card to share your skills, outline your project
            goals, and start connecting with other hackers before the event.
          </EmptyProfileDescription>
          <Button color="primary" size="md" onClick={onCreate}>
            Create My Profile
          </Button>
        </EmptyProfileContent>
        <HackerCardFrame>
          <HackerCardImage
            src={HackerDirectoryEmptyProfileCard}
            alt="Example profile card for Northy"
          />
        </HackerCardFrame>
      </EmptyProfileLayout>
    </EmptyProfilePageWrapper>
  </>
);

const EmptyProfilePageWrapper = styled(PageWrapper)`
  padding: 32px 32px 64px;

  ${({ theme }) => theme.mediaQueries.largeMobile`
    padding: 32px 24px 48px;
  `}
`;

const EmptyProfileLayout = styled.section`
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 48px;

  ${({ theme }) => theme.mediaQueries.medium`
    flex-direction: column;
    gap: 32px;
  `}
`;

const EmptyProfileContent = styled.div`
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;

const EmptyProfileTitle = styled(Text)`
  margin: 0;
  color: ${({ theme }) => theme.globalConstants.color.textBody};
  line-height: normal;
`;

const EmptyProfileDescription = styled(Text)`
  margin: 0;
  color: ${({ theme }) => theme.globalConstants.color.textBody};
  font-weight: 500;
  line-height: normal;
`;

const HackerCardFrame = styled.div`
  box-sizing: border-box;
  width: 316px;
  height: 411px;
  overflow: hidden;
  flex: 0 0 316px;
  border: 1.45px solid #eff8fa;
  border-radius: 12px;
  background: ${({ theme }) => theme.globalConstants.color.backgroundGray};

  ${({ theme }) => theme.mediaQueries.medium`
    width: min(316px, 100%);
    height: auto;
    aspect-ratio: 787 / 1024;
    flex-basis: auto;
  `}
`;

const HackerCardImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export default EmptyProfile;
